<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-07-13 11:36:47
 * @LastEditTime: 2022-08-08 20:34:10
 * @LastEditors: chenguobiao
-->
<template>
  <div class="grading-item" :class="{fail: info.pass}">
    <div class="grading-item__background-image">
      <img src="@/render/assets/images/home/grading_item_bg.png">
    </div>
    <div class="grading-item__content">
      <div class="grading-item__content__level-text">{{info.passLevel == 17 ? '无等级' : ('国际象棋 '+info.passLevel+' 级')}}</div>
      <div class="grading-item__content__date">{{info.startDate}}  {{info.startWeek}}</div>
      <div class="grading-item__content__status">
        <img :src="require(`@/render/assets/images/home/label_${info.scoreLevel}.png`)" alt="">
      </div>
      <div class="grading-item__content__level-image" :class="[`level-${info.passLevel}`]">
        <img :src="info.levelImage">
      </div>
      <div class="grading-item__content__score">
        <template v-for="(_, index) in info.startNumber">
          <img :src="require(`@/render/assets/images/home/${info.scoreLevel === 3 ? 'icon_star_gray' : 'icon_star'}.png`)" :key="index">
        </template>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['info'],
}
</script>

<style lang="scss" scoped>
  .grading-item {
    position: relative;
    width: val(380);
    height: val(220);
    background: #F4F1EF;
    box-shadow: 0px val(3) val(6) rgba(0, 0, 0, 0.16);
    border-radius: val(8);
    overflow: hidden;
    &__content {
      position: absolute;
      top: 0;
      bottom: 0;
      width: 100%;
      &__level-text {
        position: absolute;
        left: val(24);
        top: val(24);
        font-size: val(32);
        font-weight: 400;
        color: #341E10;
      }
      &__date {
        position: absolute;
        left: val(24);
        top: val(62);
        font-size: val(16);
        font-weight: 400;
        color: #341E10;
      }
      &__status {
        position: absolute;
        right: val(24);
        top: val(28);
        width: val(60);
        img {
          width: 100%;
        }
        // &__text {
        //   position: absolute;
        //   right: val(8);
        //   top: 50%;
        //   transform: translateY(-50%);
        //   font-size: val(14);
        //   color: #FFF8D8;
        // }
      }
      &__score {
        position: absolute;
        right: val(21);
        bottom: val(10);
        display: flex;
        align-items: center;
        img {
          margin-right: val(7);
          width: val(22);
          &:last-of-type {
            margin-right: 0;
          }
        }
      }
      &__level-image {
        position: absolute;
        left: val(40);
        bottom: val(10);
        width: val(56);
      }
    }
    &.fail {
      .grading-item {
        &__background-image {
          position: relative;
          &:after {
            position: absolute;
            content: '';
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            background: #000;
            opacity: 0.6;
          }
        }
        &__content {
          &__level-text {
            color: #fff;
          }
          &__date {
            font-size: val(16);
            color: #fff;
          }
          &__status {
            width: val(88);
             &__bg {
              display: none;
            }
            &__text {
              color: #fff;
              font-size: val(16);
            }
          }
          &__score__text {
            color: #4b4b4b;
          }
        }
      }
    }
  }
</style>
